<div class="row" style="margin-top: 100px;">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header card-header-icon card-header-rose">
                <h3>Partners <span class="badge badge-pill badge-success ml-1" style="font-size: larger;">{{ intCount }}</span></h3>
            </div>
            <div class="card-body">
                <button type="button" class="btn btn-success float-right mb-2" (click)="new()"><i class="fas fa-plus mr-1"></i> Create New</button>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="tableHeader">Company</th>
                            <th class="tableHeader">POC</th>
                            <th class="tableHeader">Email</th>
                            <th class="tableHeader">Phone</th>
                            <th class="tableHeader">Reason</th>
                            <th class="tableHeader text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of partners">
                            <td>{{ c.payload.doc.data().companyName }}</td>
                            <td>{{ c.payload.doc.data().contactLastName + ', ' +  c.payload.doc.data().contactFirstName }}</td>
                            <td>{{ c.payload.doc.data().email }}</td>
                            <td>{{ c.payload.doc.data().phone }}</td>
                            <td>{{ c.payload.doc.data().reason }}</td>
                            <td class="td-actions text-right">
                                <button type="button" rel="tooltip" (click)="edit(c.payload.doc.id)" title="Edit" class="btn btn-success btn-lg mr-4">
                                    <i class="fas fa-edit" style="font-size: larger;"></i>
                                </button>
                                <button type="button" rel="tooltip" (click)="delete(c.payload.doc.id)" title="Delete" class="btn btn-danger btn-lg">
                                    <i class="fas fa-trash" style="font-size: larger;"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
    

